const Header = () => {
  return (
    <header className="bg-alert">
      <h1>Busca Recetas de bebidas</h1>
    </header>
  );
};

export default Header;
